/**
 * Feature flag configuration.
 * Define your feature keys here for type-safety.
 */
export type FeatureKey =
  | 'TEST_FLAG'
  | 'TEST_FLAG2'
  | 'NEW_SWITCHBOARD'
  | 'TEMPLATE_V2'
export interface FeatureDefaults {
  development: boolean;
  staging: boolean;
  production: boolean;
}

export const FEATURES_CONFIG: Record<FeatureKey, FeatureDefaults> = {
  TEST_FLAG: {
    development: true,
    staging: true,
    production: false,
  },
  TEST_FLAG2: {
    development: true,
    staging: false,
    production: false,
  },
  NEW_SWITCHBOARD: {
    development: true,
    staging: true,
    // 20260518 - Adozione nuovo centralino
    // production: false,
    production: true,
  },
  // The TemplateV2 feature as a whole — sidebar entry, routes, and every
  // sub-action (Scarica PDF, etc). Dev-only until the new template flow
  // is validated end-to-end and the BE PDF endpoint ships. Flip staging
  // then production when ready; no code change required elsewhere.
  TEMPLATE_V2: {
    development: true,
    staging: false,
    production: false,
  },
};
